import React from 'react';

import {Select} from 'desktop/components/select/select';

import s from './savedCardsList.scss';

type PropsType = {
    cards: {id: string; name: string}[];
    onChange: (index: number) => void;
};

/**
 * Select for saved cards choosing
 *
 * @constructor
 */
export const SavedCardsList: React.FC<PropsType> = ({cards = [], onChange}) => (
    <div className={s.container}>
        <p className={s.text}>Pay with saved credit card</p>
        <Select
            onChange={newValue => {
                onChange(Number(newValue));
            }}
            options={cards.map(({name}, index) => ({
                label: name,
                value: index,
            }))}
            name="cards"
        />
    </div>
);
